const type = 'standard'
const path = 'server/nodejs'
const name = 'server.js'
const fullPath = `${path}/${name}`

export { type, path, name, fullPath }
